import React, { useState } from 'react';
import { Typography, Box, InputAdornment, IconButton, Alert } from '@mui/material';
import TextFormField from '@components/FormFields/TextFormField/TextFormField.component';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useFormState } from 'react-final-form';

interface PasswordCardProps {
  errorMessage?: string | null;
}

const PasswordCard = ({ errorMessage }: PasswordCardProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setConfirmPassword] = useState(false);
  const formState = useFormState();

  return (
    <>
      <Box>
        <Typography variant="h1">Choose your password</Typography>
        <Typography variant="h4">
          Must be at least 8 charachters long and contain atleast 1 uppercase letter, 1 lowercase letter and 1 special character
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px'}}>
        <TextFormField
          required
          name="password"
          label="Create a password"
          variant="outlined"
          type={showPassword ? 'text' : 'password'}
          fullWidth
          slotProps={{
          input: {
            endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => setShowPassword((prev) => !prev)}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
          }
        }}
        />
        <Box>
          <TextFormField
            required
            name="confirmPassword"
            label="Confirm password"
            variant="outlined"
            type={showConfirmPassword ? 'text' : 'password'}
            fullWidth
            validate={(value) => {
              if (value !== formState.values?.password) return 'Passwords do not match';
            }}
            slotProps={{
            input: {
              endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setConfirmPassword((prev) => !prev)}
                  edge="end"
                >
                  {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
            }
          }}
          />
          {errorMessage && (
            <Alert severity="error" sx={{ marginTop: '10px' }}>
              {errorMessage}
            </Alert>
          )}
        </Box>
      </Box>
    </>
  );
};

export default PasswordCard;
